package com.milta.core.localization.translations.it

import com.milta.core.localization.AdminPromptsStrings

internal val AdminPrompts = AdminPromptsStrings(
    loading = "Caricamento…",
    errorNoConnection = "Impossibile contattare il server — controlla la tua connessione.",
    errorGeneric = "Si è verificato un errore. Riprova più tardi.",
    contractLockedNotice = "🔒 Il contratto di output (formato JSON) resta bloccato — viene aggiunto automaticamente lato server dopo il testo modificato, per non rompere mai l'estrazione in produzione.",
    notModifiedLabel = "Valore predefinito — mai modificato",
    modifiedOnPrefix = "Modificato il",
    resetToDefaultAction = "↺ Ripristina ai valori predefiniti",
    editableBodyLabel = "✏️ Corpo modificabile — regole di business",
    markdownBoldSnippet = "**testo in grassetto**",
    markdownItalicSnippet = "*testo in corsivo*",
    markdownCodeSnippet = "`codice`",
    markdownHeadingSnippet = "## Titolo",
    markdownBulletSnippet = "- elemento elenco",
    markdownNumberedSnippet = "1. elemento elenco",
    markdownQuoteSnippet = "> citazione",
    previewToggleEdit = "✏️ Modifica",
    previewToggleShow = "👁 Anteprima",
    contractFooterLabel = "🔒 Contratto di output — bloccato, aggiunto automaticamente",
    actionErrorOffline = "Fallito — controlla la tua connessione.",
    actionErrorGeneric = "Salvataggio non riuscito, riprova.",
    unsavedChangesNotice = "● Modifiche non salvate",
    savingAction = "Salvataggio…",
    saveAction = "Salva modifiche",
)
